// extracted by mini-css-extract-plugin
export default {"customFooter":"Footer_customFooter__nKwLV","footerLinks":"Footer_footerLinks__8DNE+"};